/*
 * Section scroll-reveal — adds .is-revealed when a section enters
 * the viewport, triggering CSS transitions defined in
 * professional-polish.css. Skips header / footer groups.
 */
(function () {
  if (!('IntersectionObserver' in window)) {
    // Fallback: reveal everything immediately
    document.querySelectorAll('.shopify-section').forEach((s) => s.classList.add('is-revealed'));
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.shopify-section').forEach((s) => s.classList.add('is-revealed'));
    return;
  }

  const SKIP = '.shopify-section-group-header-group, .shopify-section-group-footer-group';

  function init() {
    const sections = document.querySelectorAll(`.shopify-section:not(${SKIP})`);
    if (!sections.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach((s) => {
      s.classList.add('section-reveal');
      obs.observe(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Scroll progress indicator + sticky header shrink
  const progressBar = document.createElement('div');
  progressBar.className = 'scroll-progress';
  progressBar.setAttribute('aria-hidden', 'true');
  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(progressBar);
  }, { once: true });

  let ticking = false;
  function onScroll() {
    const y = window.scrollY;
    if (!ticking) {
      requestAnimationFrame(() => {
        const doc = document.documentElement;
        const max = (doc.scrollHeight - doc.clientHeight) || 1;
        const pct = Math.min(100, Math.max(0, (y / max) * 100));
        progressBar.style.width = pct + '%';
        document.documentElement.classList.toggle('is-scrolled', y > 60);
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
